import { render, staticRenderFns } from "./PatentPriorityForm.vue?vue&type=template&id=1b4948ea&"
import script from "./PatentPriorityForm.vue?vue&type=script&lang=js&"
export * from "./PatentPriorityForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentPriorityForm.vue?vue&type=style&index=0&id=1b4948ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports